<template>
  <main role="main" class="col content-spacing">
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <h1 class="h2" v-if="viewData.powerPlant">
        Detalhes Usina {{ viewData.powerPlant.name }}
      </h1>
      <div class="btn-toolbar mb-2 mb-md-0" v-if="viewData.powerPlant">
        <div class="btn-group mr-2">
          <BaseButtonComponent
            :to="`/power-plant/${viewData.powerPlant.id}/data/new`"
            variant="primary-action"
            >Novo detalhe</BaseButtonComponent
          >
        </div>
      </div>
    </div>

    <b-row v-if="viewData.powerPlant">
      <b-col>
        <b-breadcrumb
          :items="[
            {
              text: 'Lista de Usinas',
              href: `#/power-plants`,
            },
            {
              text: 'Usina ' + viewData.powerPlant.name,
              href: '#',
              active: true,
            },
          ]"
        ></b-breadcrumb>
      </b-col>
    </b-row>

    <loading-list v-if="viewData.loading"></loading-list>
    <div
      class="d-flex justify-content-between flex-column h-100"
      v-else-if="!viewData.loading && state.list && state.list.length > 0"
    >
      <v-table>
        <thead>
          <tr>
            <td>Início</td>
            <td>Término</td>
            <td>Potência instalada</td>
            <td>Injeção projetada</td>
            <td>Injeção disponível</td>
            <td>Injeção efetiva</td>
            <td>Créditos</td>
            <td>Receita</td>
            <td>Capex</td>
            <td>Opex</td>
            <td>Resultado</td>
            <td>Custo de energia</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in state.list" :key="item.id">
            <td>{{ formatDate(item.start) }}</td>
            <td>{{ formatDate(item.end) }}</td>
            <td>{{ formatNumber(item.powerInstalled) }}</td>
            <td>{{ formatNumber(item.projectedInjection) }}</td>
            <td>{{ formatNumber(item.availableInjection) }}</td>
            <td>{{ formatNumber(item.injection) }}</td>
            <td>{{ formatNumber(item.credits) }}</td>
            <td>{{ item.total | currency }}</td>
            <td>{{ formatNumber(item.capex) }}</td>
            <td>{{ formatNumber(item.opex) }}</td>
            <td>{{ item.result | currency }}</td>
            <td>{{ item.energyCost | currency }}</td>
            <td style="text-align: right">
              <BaseButtonComponent
                :to="
                  `/power-plant/${viewData.powerPlant.id}/data/edit/${item.id}`
                "
                size="sm"
                v-b-tooltip.hover
                title="Editar"
                variant="primary-action"
              >
                <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
              <BaseButtonComponent
                @click="() => remove(item)"
                size="sm"
                v-b-tooltip.hover
                title="Excluir"
                variant="danger"
              >
                <b-icon icon="trash" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
            </td>
          </tr>
        </tbody>
      </v-table>

      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="state.pageCount"
        use-router
      ></b-pagination-nav>
    </div>
    <empty-list v-else-if="!viewData.loading"></empty-list>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import moment from 'moment-timezone';
import { Api } from '../../vue/api';
import { BaseButtonComponent } from '../../ui/buttons';

const API = new Api();

export default {
  name: 'power-plant-data-index',
  data: function() {
    return {
      state: {
        list: [],
        page: 1,
        pageCount: 1,
        count: 0,
      },
      viewData: {
        loading: true,
        search: '',
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    moment.locale('pt-BR');
    const _id = this.$route.params ? this.$route.params.id : 0;

    if (_id) {
      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/power-plant/' + _id,
          method: 'get',
        });

        this.viewData.powerPlant = result.model;
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }

      await this.getAll();
    }
  },
  methods: {
    formatNumber(number) {
      return parseFloat(number || 0).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    formatDate(date) {
      return moment(date).format('L');
    },
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },
    search() {
      this.$router.push({
        query: { page: 1, search: this.viewData.search },
      });
    },
    async getAll() {
      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: `/power-plant/${this.viewData.powerPlant.id}/data`,
          method: 'get',
        });

        this.state.list = result.model;
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
    async remove(item) {
      const ok = await this.$bvModal.msgBoxConfirm(
        `Deseja mesmo excluir [${this.formatDate(item.start)}] ?`,
        {
          title: 'Confirmar Exclusão',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      );

      if (!ok) {
        return;
      }

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path:
            '/power-plant/' + this.viewData.powerPlant.id + '/data/' + item.id,
          method: 'delete',
        });

        this.$toast.success('Detalhes excluídos com sucesso');
        await this.getAll();
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
  },
  components: {
    BaseButtonComponent,
  },
};
</script>
